import React, { useEffect, useRef, useState } from 'react'

interface FailedOrderTooltipProps {
  count: number | string
  content: string
}

const FailedOrderTooltip: React.FC<FailedOrderTooltipProps> = ({
  count,
  content,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const toggleTooltip = () => setIsOpen((prev) => !prev)

  const handleCopy = () => {
    navigator.clipboard.writeText(content || '')
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={toggleTooltip}
        style={{
          cursor: 'pointer',
          color: 'black',
          background: 'none',
          border: 'none',
          padding: 0,
        }}>
        {count}
      </button>

      {isOpen && (
        <div
          ref={tooltipRef}
          style={{
            position: 'absolute',
            top: '120%',
            left: 0,
            zIndex: 999,
            width: '300px',
            height: '150px',
            backgroundColor: '#f9f9f9',
            border: '1px solid #ccc',
            borderRadius: '6px',
            overflowY: 'auto',
            padding: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              margin: 0,
            }}>
            {content}
          </pre>
          <button
            onClick={handleCopy}
            style={{
              marginTop: '10px',
              backgroundColor: 'orange',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease-in-out',
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = 'rgba(255,165,0,0.7)')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = 'orange')
            }>
            Copy
          </button>
        </div>
      )}
    </div>
  )
}

export default FailedOrderTooltip
